import Firebase from "firebase";
import router from "@/router";
import VueCookies from "vue-cookies";

const state = {
  isSearchingSocio: false,
  socio: null,
  isSuccess: false
};

const mutations = {
  setIsSearchingSocio: (state, payload) => {
    state.isSearchingSocio = payload;
  },
  setSocioHasFound: (state, payload) => {
    state.socioHasFound = payload;
  },
  setSocio: (state, payload) => {
    state.socio = payload;
  },
  setIsSuccess: (state, payload) => {
    state.isSuccess = payload;
  }
};

const actions = {
  getSocioInFirestore: async ({ commit }, cpfSocio) => {
    commit("setIsSearchingSocio", true);
    commit("setSocio", null);

    await Firebase.firestore()
      .collection("associados")
      .where("cpf", "==", cpfSocio)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(function(doc) {
          // console.log("Socio", doc.data());
          commit("setSocio", doc.data());
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });

    commit("setIsSearchingSocio", false);
  },

  saveSocioInFirestore: async ({ commit }, socio) => {
    await Firebase.firestore()
      .collection("associados")
      .doc(socio._id)
      .set(socio)
      .then(() => {
        console.log("Success Add Socio In Firestore");
        commit("setIsSuccess", true);
      })
      .catch(error => {
        console.log("Error", error);
        commit("setIsSuccess", false);
      });
  },

  updateSocioInFirestore: async ({ commit }, socio) => {
    await Firebase.firestore()
      .collection("associados")
      .doc(socio._id)
      .update(socio)
      .then(() => {
        console.log("Success Add Socio In Firestore");
        commit("setIsSuccess", true);
      })
      .catch(error => {
        console.log("Error", error);
        commit("setIsSuccess", false);
      });
  },

  addSocioAssociacaoInFirestore: async ({ commit }, socio) => {
    let associacaoId = VueCookies.get("IDASSOCIACAO");

    await Firebase.firestore()
      .collection("associados")
      .doc(socio._id)
      .update({
        [`associacoes.${associacaoId}`]: socio.associacoes[`${associacaoId}`]
      })
      .then(() => {
        console.log("Success Add Socio In Firestore");
        commit("setIsSuccess", true);
      })
      .catch(error => {
        console.log("Error", error);
        commit("setIsSuccess", false);
      });
  },

  saveMensalidadeSocioInFirestore: async ({commit}, payload) => {
    let userRef = Firebase.firestore().collection("associados").doc(payload.socio._id)
    let associacaoId = VueCookies.get("IDASSOCIACAO");

    //Apaga a informação do mês no qual ocorreu o pagamento
    if (payload.del) {
      await userRef.update({
        [`associacoes.${associacaoId}.mensalidade.${payload.ano}.${payload.mes._id}`]: Firebase.firestore.FieldValue.delete()
      }).then(() => {
        console.log("Success Add Mensalidade In Firestore");
        commit("setIsSuccess", true);
      }).catch(error => {
        console.log("Error", error);
        commit("setIsSuccess", false);
      });
      return;
    }

    //Salva a informação do mês no qual ocorreu o pagamento
    await userRef.update({
      [`associacoes.${associacaoId}.mensalidade.${payload.ano}.${payload.mes._id}`]: payload.mes
    }).then(() => {
      console.log("Success Add Mensalidade In Firestore");
      commit("setIsSuccess", true);
    }).catch(error => {
      console.log("Error", error);
      commit("setIsSuccess", false);
    });
  }
};

const getters = {
  getIsSearchingSocio: state => state.isSearchingSocio,
  getSocio: state => state.socio,
  getIsSuccess: state => state.isSuccess
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
